// extracted by mini-css-extract-plugin
export default {"container":"Skills_container__5+yxw","header":"Skills_header__f19XJ","technology-container":"Skills_technology-container__Y3bni","technology":"Skills_technology__Z+m+X"};